import React from 'react';
import { QuoteIcon, UserIcon, CheckCircleIcon } from 'lucide-react';
export const HomeTestimonials = () => {
  return <section className="my-12" data-id="element-2624">
      <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2" data-id="element-2625">
        Real Women, Verified Results
      </h2>
      <p className="text-base text-slate-800 leading-relaxed mb-8" data-id="element-2626">
        Read the experiences of women who have used our clinically-validated
        solutions. All testimonials are from verified users whose results have
        been documented through follow-up clinical assessments.
      </p>
      <div className="space-y-8" data-id="element-2627">
        {/* Testimonial 1 */}
        <div className="border border-slate-200 p-5 sm:p-6 bg-white" data-id="element-2628">
          <div className="flex mb-3" data-id="element-2629">
            <QuoteIcon className="h-5 w-5 text-slate-400 mr-2" data-id="element-2630" />
            <span className="text-xs uppercase tracking-wider text-slate-500 font-medium flex items-center" data-id="element-2631">
              Verified Experience
              <CheckCircleIcon className="h-3 w-3 text-green-600 ml-1" data-id="element-2632" />
            </span>
          </div>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-2633">
            <div className="sm:w-1/4" data-id="element-2634">
              <img src="https://images.unsplash.com/photo-1499952127939-9bbf5af6c51c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1176&q=80" alt="Caroline K." className="w-full h-auto rounded-lg object-cover aspect-square" data-id="element-2635" />
            </div>
            <div className="sm:w-3/4" data-id="element-2636">
              <p className="text-base text-slate-700 leading-relaxed italic mb-5 border-l-2 border-slate-300 pl-4" data-id="element-2637">
                "After 6 years of struggling with recurring BV, I had tried
                everything - 5 rounds of antibiotics, boric acid every night,
                and every probiotic on Amazon. Nothing worked until I found this
                solution. Within 3 days, the discharge started clearing. By week
                1, there was no smell in the morning. It's been 6 months now
                without a single infection. I feel like myself again."
              </p>
              <div className="mt-4 bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-2638">
                <h4 className="font-medium text-slate-900 text-sm" data-id="element-2639">
                  Before/After Results:
                </h4>
                <div className="grid grid-cols-2 gap-2 mt-2 text-xs" data-id="element-2640">
                  <div className="bg-white p-2 rounded border border-slate-200" data-id="element-2641">
                    <span className="font-medium text-slate-900" data-id="element-2642">Before:</span>
                    <ul className="mt-1 text-slate-700 space-y-1" data-id="element-2643">
                      <li data-id="element-2644">• Recurring BV every 4-6 weeks</li>
                      <li data-id="element-2645">• Constant odor and discharge</li>
                      <li data-id="element-2646">• Avoiding intimacy</li>
                    </ul>
                  </div>
                  <div className="bg-white p-2 rounded border border-slate-200" data-id="element-2647">
                    <span className="font-medium text-slate-900" data-id="element-2648">After:</span>
                    <ul className="mt-1 text-slate-700 space-y-1" data-id="element-2649">
                      <li data-id="element-2650">• No infections for 6+ months</li>
                      <li data-id="element-2651">• Normal discharge, no odor</li>
                      <li data-id="element-2652">• Confidence restored</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-100 pt-4 mt-4" data-id="element-2653">
                <div className="w-8 h-8 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 mr-3" data-id="element-2654">
                  <UserIcon className="h-4 w-4" data-id="element-2655" />
                </div>
                <div data-id="element-2656">
                  <p className="font-serif text-slate-900 font-medium" data-id="element-2657">
                    — Caroline K., 41
                  </p>
                  <p className="text-xs sm:text-sm text-slate-500 mt-1" data-id="element-2658">
                    Teacher, Had recurring BV for 6 years
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Testimonial 2 */}
        <div className="border border-slate-200 p-5 sm:p-6 bg-white" data-id="element-2659">
          <div className="flex mb-3" data-id="element-2660">
            <QuoteIcon className="h-5 w-5 text-slate-400 mr-2" data-id="element-2661" />
            <span className="text-xs uppercase tracking-wider text-slate-500 font-medium flex items-center" data-id="element-2662">
              Verified Experience
              <CheckCircleIcon className="h-3 w-3 text-green-600 ml-1" data-id="element-2663" />
            </span>
          </div>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-2664">
            <div className="sm:w-1/4" data-id="element-2665">
              <img src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Margaret W." className="w-full h-auto rounded-lg object-cover aspect-square" data-id="element-2666" />
            </div>
            <div className="sm:w-3/4" data-id="element-2667">
              <p className="text-base text-slate-700 leading-relaxed italic mb-5 border-l-2 border-slate-300 pl-4" data-id="element-2668">
                "The hot flashes were unbearable - up to 15 per day, waking me
                up 4-5 times each night drenched in sweat. After 3 weeks on the
                hormone balance protocol, my hot flashes decreased to just 2-3
                mild ones per day. I'm sleeping through the night again and have
                energy I haven't felt in years. My husband says I'm a completely
                different person."
              </p>
              <div className="mt-4 bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-2669">
                <h4 className="font-medium text-slate-900 text-sm" data-id="element-2670">
                  Before/After Results:
                </h4>
                <div className="grid grid-cols-2 gap-2 mt-2 text-xs" data-id="element-2671">
                  <div className="bg-white p-2 rounded border border-slate-200" data-id="element-2672">
                    <span className="font-medium text-slate-900" data-id="element-2673">Before:</span>
                    <ul className="mt-1 text-slate-700 space-y-1" data-id="element-2674">
                      <li data-id="element-2675">• 12-15 hot flashes daily</li>
                      <li data-id="element-2676">• Waking 4-5 times nightly</li>
                      <li data-id="element-2677">• Constant exhaustion</li>
                    </ul>
                  </div>
                  <div className="bg-white p-2 rounded border border-slate-200" data-id="element-2678">
                    <span className="font-medium text-slate-900" data-id="element-2679">After:</span>
                    <ul className="mt-1 text-slate-700 space-y-1" data-id="element-2680">
                      <li data-id="element-2681">• 2-3 mild hot flashes daily</li>
                      <li data-id="element-2682">• Sleeping 6-7 hours uninterrupted</li>
                      <li data-id="element-2683">• Energy levels restored</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="flex items-center border-t border-slate-100 pt-4 mt-4" data-id="element-2684">
                <div className="w-8 h-8 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 mr-3" data-id="element-2685">
                  <UserIcon className="h-4 w-4" data-id="element-2686" />
                </div>
                <div data-id="element-2687">
                  <p className="font-serif text-slate-900 font-medium" data-id="element-2688">
                    — Margaret W., 53
                  </p>
                  <p className="text-xs sm:text-sm text-slate-500 mt-1" data-id="element-2689">
                    Marketing Director, Experiencing severe menopause symptoms
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};